import * as angular from 'angular';
import * as _ from 'lodash';

import { Unsubscribe } from 'redux';
import ngRedux from 'ng-redux';

import { ComponentDefinition, Group } from '../../../models';
import { Store } from '../../../stateManagement/Store';
import { IGroupActionsService } from '../../../stateManagement';

interface MapDispatchToProps {
    loadGroups: () => angular.IPromise<Group[]>;
}


class GroupWithReconciliationSelectorController implements angular.IComponentController, MapDispatchToProps {
    groups: Group[];
    loadGroups: () => angular.IPromise<Group[]>;
    private _unsubscribe: Unsubscribe;

    static $inject = ['$ngRedux', 'groupActionsService'];
    constructor(private _$ngRedux: ngRedux.INgRedux,
        private _gac: IGroupActionsService) {
    }

    $onInit() {
        this._unsubscribe = this._$ngRedux.connect((store: Store) => {
            return {
                groups: _.values(store.groups.dictionary)
                    .filter((d: Group) => d.reconciliationMatrix && d.reconciliationMatrix.length > 0)
            };
        }, dispatch => this.mapDispatchToProps(dispatch))(this);
        this.loadGroups();
    }

    private mapDispatchToProps(dispatch: Function): MapDispatchToProps {
        return {
            loadGroups: () => dispatch(this._gac.getAll())
        };
    }

    $onDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }
}

export const wtGroupWithReconciliationSelector: ComponentDefinition = {
    componentId: 'wtGroupWithReconciliationSelector',
    controller: GroupWithReconciliationSelectorController,
    template: require('./groupWithReconciliationSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        formController: '='
    }
};
